<template>
  <div
    class="select-box-group"
    v-bind:style="{
      display: displayBetweenSelectBox ? `inline-flex` : 'block',
    }"
    v-bind:class="displayBetweenSelectBox ? `select-box-multi-line` : ''"
  >
    <div class="select-from">
      <DxSelectBox
        id="custom-templates"
        :data-source="fromDatasource"
        :on-value-changed="onSelectionChanged"
        :items="toFromItems"
        :display-expr="displayExpr"
        :value-expr="valueExpr"
        :searchEnabled="true"
        :openOnFieldClick="true"
        searchMode="contains"
        :searchExpr="searchExpr"
        :itemTemplate="itemTemplate"
        :showClearButton="true"
        @initialized="initialized"
        ref="select-from-value"
        :validationMessageMode="validationMessageMode"
        @itemClick="onItemClick"
        :value="fromValue"
        :readOnly="setReadOnly"
        :fieldTemplate="fieldTemplate"
        :drop-down-options="{ width: displayBetweenSelectBox ? 200 : 'auto' }"
      >
        <DxSelectBoxButton
          :options="searchTypes"
          name="search"
          location="before"
        />
        <!-- <DxSelectBoxButton
          name="clear-btn"
          :options="selectFromClearBtn"
          location="after"
        /> -->

        <DxSelectBoxButton name="clear" location="after" />

        <template #select-from-clear>
          <div>
            <span class="dx-clear-button-area" @click="clearSelectFrom"
              ><span class="dx-icon dx-icon-clear"></span
            ></span>
          </div>
        </template>

        <DxSelectBoxButton name="dropDown" icon="dropDown" />
        <template #item-template="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{ data[primaryText] }}</span>
            <span class="auto-complete-secondary">{{
              data[secondaryText]
            }}</span>
          </div>
        </template>

        <template #default-item-template="{ data }">
          <div>
            <span>{{ data }}</span>
          </div>
        </template>

        <template #field-template="{ data }">
          <!-- <div class="gc-auto-cmp">{{ data.Description }}</div> -->
          <DxTextBox
            :value="gridData.column.displayValue(data)"
            :read-only="true"
            class="product-name"
          />
        </template>

        <template #show-drop-down>
          <div>
            <DxDropDownButton
              class="search-option"
              :showArrowIcon="false"
              :stylingMode="'text'"
              :items="filterDateRangeOptions()"
              keyExpr="value"
              displayExpr="text"
              :drop-down-options="{ width: 250 }"
              :onItemClick="searchOptionItemClick.bind(this)"
              :useSelectMode="true"
              :value="selectToValue"
              :selectedItemKey="selectedOperator"
              width="25"
            >
            </DxDropDownButton>
          </div>
        </template>
      </DxSelectBox>
    </div>

    <div class="select-to" v-if="displayBetweenSelectBox">
      <span>To</span>
      <DxSelectBox
        id="custom-templates"
        :data-source="toDatasource"
        :on-value-changed="onToSelectionChanged"
        :items="toDataItems"
        :display-expr="displayExpr"
        :value-expr="valueExpr"
        :searchEnabled="true"
        :openOnFieldClick="true"
        searchMode="contains"
        :searchExpr="searchExpr"
        :itemTemplate="itemTemplate"
        :showClearButton="showClearButton"
        ref="select-to-value"
        :validationMessageMode="validationMessageMode"
        @itemClick="onItemClick"
        :value="toValue"
        :readOnly="setReadOnly"
        :fieldTemplate="fieldTemplate"
        :drop-down-options="{ width: 200 }"
      >
        <template #item-template="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{ data[primaryText] }}</span>
            <span class="auto-complete-secondary">{{
              data[secondaryText]
            }}</span>
          </div>
        </template>
      </DxSelectBox>
    </div>
  </div>
</template>
<script>
import {
  DxSelectBox,
  DxButton as DxSelectBoxButton,
} from "devextreme-vue/select-box";
import { GridReportService } from "../_services/api/reports/grid-report.service";

export default {
  components: {
    DxSelectBox,
    DxSelectBoxButton,
  },
  props: {
    valueChangeCallBack: {
      type: Function,
      default: () => function () {},
    },
    onValueChanged: {
      type: Function,
      default: () => function () {},
    },
    selectBoxOptions: {
      type: [Object, Array],
      default: () => {},
    },
    gridData: {
      type: Object,
      default: () => {},
    },
    // value: {
    //   type: [String, Number],
    //   default: undefined,
    // },
    showClearButton: {
      type: Boolean,
      default: true,
    },
    setReadOnly: {
      type: Boolean,
      default: false,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      searchTypes: {
        template: "show-drop-down",
        elementAttr: { class: "search-option-drop-down" },
        visible: true,
      },
      searchOptionItems: [
        { icon: "equal", text: "Equals", value: "=" },
        { icon: "less", text: "Less than", value: "<" },
        { icon: "greater", text: "Greater than", value: ">" },
        { icon: "lessorequal", text: "Less than or equal to", value: "<=" },
        {
          icon: "greaterorequal",
          text: "Greater than or equal to",
          value: ">=",
        },
        { icon: "range", text: "Between", value: "between" },
      ],

      selectToValue: undefined,
      selectedOperator: undefined,
      displayBetweenSelectBox: false,

      // datasource: this.selectBoxOptions[0].dataSourceConfig.endpoint
      //   ? GridReportService.dataSourceConfig(
      //       this.selectBoxOptions[0].dataSourceConfig.endpoint,
      //       {
      //         select: this.selectBoxOptions[0].dataSourceConfig.select
      //           ? this.selectBoxOptions[0].dataSourceConfig.select
      //           : [
      //               this.selectBoxOptions[0].valueExpr,
      //               this.selectBoxOptions[0].displayExpr,
      //             ],
      //         sort: this.selectBoxOptions[0].dataSourceConfig.sort
      //           ? this.selectBoxOptions[0].dataSourceConfig.sort
      //           : undefined,
      //         filter: this.selectBoxOptions[0].dataSourceConfig.filter
      //           ? this.selectBoxOptions[0].dataSourceConfig.filter
      //           : undefined,
      //       }
      //     )
      //   : undefined,
      // toDatasource: this.selectBoxOptions[0].dataSourceConfig.endpoint
      //   ? GridReportService.dataSourceConfig(
      //       this.selectBoxOptions[0].dataSourceConfig.endpoint,
      //       {
      //         select: this.selectBoxOptions[0].dataSourceConfig.select
      //           ? this.selectBoxOptions[0].dataSourceConfig.select
      //           : [
      //               this.selectBoxOptions[0].valueExpr,
      //               this.selectBoxOptions[0].displayExpr,
      //             ],
      //         sort: this.selectBoxOptions[0].dataSourceConfig.sort
      //           ? this.selectBoxOptions[0].dataSourceConfig.sort
      //           : undefined,
      //         filter: this.setToFilter,
      //         postProcess: this.toSelectPostProcess,
      //       }
      //     )
      //   : undefined,
      items: this.selectBoxOptions[0].dataSourceConfig.data
        ? this.selectBoxOptions[0].dataSourceConfig.data
        : undefined,
      valueExpr: this.selectBoxOptions[0].valueExpr
        ? this.selectBoxOptions[0].valueExpr
        : undefined,
      displayExpr: this.selectBoxOptions[0].displayExpr
        ? this.selectBoxOptions[0].displayExpr
        : undefined,
      searchExpr: this.selectBoxOptions[0].displayExpr
        ? [
            this.selectBoxOptions[0].valueExpr,
            this.selectBoxOptions[0].displayExpr,
          ]
        : undefined,
      primaryText: this.selectBoxOptions[0].editorTemplate
        ? this.selectBoxOptions[0].editorTemplate.primary[0].dataField
        : undefined,
      secondaryText: this.selectBoxOptions[0].editorTemplate
        ? this.selectBoxOptions[0].editorTemplate.secondary
          ? this.selectBoxOptions[0].editorTemplate.secondary[0].dataField
          : undefined
        : undefined,
      itemTemplate: this.selectBoxOptions[0].editorTemplate
        ? "item-template"
        : "default-item-template",
      // showClearButton: true,
      //   widgetItem: this.selectBoxOptions.editorType,
      dataField: this.selectBoxOptions[0].dataField,
      defaultValue: this.selectBoxOptions[0].defaultValue
        ? this.selectBoxOptions[0].defaultValue
        : undefined,
      validationMessageMode: this.selectBoxOptions[0].validationMessageMode
        ? this.selectBoxOptions[0].validationMessageMode
        : "auto",
      readOnly: this.selectBoxOptions[0].readOnly || this.setReadOnly,
      fieldTemplate: this.selectBoxOptions[0].fieldTemplate
        ? "field-template"
        : null,
      toValue: undefined,
      fromValue: undefined,
    };
  },
  mounted() {
    this.selectedOperator = "=";
    if (this.defaultValue && this.defaultValue.length != 0) {
      if (
        Object.keys(this.selectBoxOptions[0].defaultValue).length > 0 &&
        this.selectBoxOptions[0].filterOperator == "between" &&
        !this.dataModel.filterOperator
      ) {
        this.fromValue = this.selectBoxOptions[0].defaultValue.from;
        this.toValue = this.selectBoxOptions[0].defaultValue.to;
        this.selectedOperator = "between";
        this.displayBetweenSelectBox = true;
      } else {
        if (this.dataModel.filterOperator == "between") {
          this.fromValue = this.dataModel.fromValue;
          this.toValue = this.dataModel.toValue;
          this.selectedOperator = "between";
          this.displayBetweenSelectBox = true;
        }
        if (this.dataModel.fromValue) {
          this.defaultValue = [this.dataModel.fromValue];
        } else {
          this.onSelectionChanged({ value: this.defaultValue[0] });
        }
      }

      if (this.selectBoxOptions[0].filterOperator) {
        this.selectedOperator = this.dataModel.filterOperator =
          this.selectBoxOptions[0].filterOperator;
      }

      if (this.dataModel.filterOperator) {
        this.selectedOperator = this.dataModel.filterOperator;
      }
    } else {
      if (this.dataModel.fromValue)
        this.defaultValue = this.dataModel.fromValue;
    }
  },
  methods: {
    clearSelectFrom() {
      this.fromValue = undefined;

      var datebox = this.$refs["select-from-value"].instance;
      datebox.reset();
    },
    searchOptionItemClick(e) {
      if (this.$refs["select-to-value"]) {
        this.toValue = undefined;
        var datebox = this.$refs["select-to-value"].instance;
        datebox.reset();
      }

      this.selectedOperator = e.itemData.value;
      this.dataModel["filterOperator"] = e.itemData.value;

      if (e.itemData.value == "between") this.displayBetweenSelectBox = true;
      else this.displayBetweenSelectBox = false;

      if (this.fromValue) {
        this.onSelectionChanged({ value: this.fromValue });
      }
    },
    filterDateRangeOptions() {
      return this.searchOptionItems;
    },
    onSelectionChanged(e) {
      this.fromValue = e.value;
      this.dataModel["fromValue"] = e.value;
      this.setFilterArray(e);
    },
    onToSelectionChanged(e) {
      this.toValue = e.value;
      this.dataModel["toValue"] = e.value;
      this.setFilterArray(e);
    },
    setFilterArray(e) {
      let filter = [];
      var setFilter = [];

      if (this.selectedOperator != "between" && e.value) {
        setFilter = [];
        setFilter[0] = this.selectBoxOptions[0].dataField;
        setFilter[1] = this.selectedOperator ? this.selectedOperator : "=";
        setFilter[2] = e.value;
        filter.push(setFilter);
      } else {
        if (
          (this.fromValue && !this.toValue) ||
          (!this.fromValue && this.toValue)
        ) {
          setFilter = [];
          setFilter[0] = this.selectBoxOptions[0].dataField;
          setFilter[1] = !this.toValue ? ">=" : !this.fromValue ? "<=" : "=";
          setFilter[2] = this.fromValue
            ? this.fromValue
            : this.toValue
            ? this.toValue
            : null;
          filter.push(setFilter);
        } else if (this.fromValue && this.toValue) {
          setFilter = [];
          setFilter[0] = this.selectBoxOptions[0].dataField;
          setFilter[1] = ">=";
          setFilter[2] = this.fromValue;
          filter.push(setFilter);
          filter.push("and");
          setFilter = [];
          setFilter[0] = this.selectBoxOptions[0].dataField;
          setFilter[1] = "<=";
          setFilter[2] = this.toValue;
          filter.push(setFilter);
        }
      }

      if (this.selectBoxOptions[0].formLocation == "form-report") {
        this.valueChangeCallBack(this.dataField, e.value);
      } else if (this.selectBoxOptions[0].formLocation == "data-grid") return;
      else this.valueChangeCallBack(this.dataField, filter);
    },
    initialized(e) {
      if (this.defaultValue) {
        var defaultValue = undefined;
        if (Array.isArray(this.defaultValue)) {
          defaultValue = this.defaultValue[0];
        } else if (
          Object.keys(this.selectBoxOptions[0].defaultValue).length > 0
        ) {
          defaultValue = this.selectBoxOptions[0].defaultValue.from;
        } else defaultValue = this.defaultValue;
        e.component.beginUpdate();
        e.component.option("value", defaultValue);
        e.component.endUpdate();

        this.fromValue = defaultValue;

        this.$nextTick(() => {
          if (this.selectBoxOptions[0].filterOperator) {
            this.selectedOperator = this.dataModel.filterOperator =
              this.selectBoxOptions[0].filterOperator;
          }

          if (defaultValue) this.onSelectionChanged({ value: defaultValue });
        });
      }
    },
    onItemClick(e) {
      if (this.selectBoxOptions[0].formLocation == "data-grid")
        this.valueChangeCallBack(e, this.gridData);
    },
  },
  computed: {
    fromDatasource() {
      return this.selectBoxOptions[0].dataSourceConfig.endpoint
        ? GridReportService.dataSourceConfig(
            this.selectBoxOptions[0].dataSourceConfig.endpoint,
            {
              select: this.selectBoxOptions[0].dataSourceConfig.select
                ? this.selectBoxOptions[0].dataSourceConfig.select
                : [
                    this.selectBoxOptions[0].valueExpr,
                    this.selectBoxOptions[0].displayExpr,
                  ],
              sort: this.selectBoxOptions[0].dataSourceConfig.sort
                ? this.selectBoxOptions[0].dataSourceConfig.sort
                : undefined,
              filter: this.setFromFilter,
            },
          )
        : undefined;
    },
    toDatasource() {
      return this.selectBoxOptions[0].dataSourceConfig.endpoint
        ? GridReportService.dataSourceConfig(
            this.selectBoxOptions[0].dataSourceConfig.endpoint,
            {
              select: this.selectBoxOptions[0].dataSourceConfig.select
                ? this.selectBoxOptions[0].dataSourceConfig.select
                : [
                    this.selectBoxOptions[0].valueExpr,
                    this.selectBoxOptions[0].displayExpr,
                  ],
              sort: this.selectBoxOptions[0].dataSourceConfig.sort
                ? this.selectBoxOptions[0].dataSourceConfig.sort
                : undefined,
              filter: this.setToFilter,
              // postProcess: this.toSelectPostProcess,
            },
          )
        : undefined;
    },
    setFromFilter() {
      var filter = this.selectBoxOptions[0].dataSourceConfig.filter
        ? this.selectBoxOptions[0].dataSourceConfig.filter
        : undefined;

      if (this.toValue) {
        if (!filter) filter = [];
        if (filter.length == 0) {
          filter.push([this.valueExpr, "<", this.toValue]);
        }
      }
      return filter;
    },
    setToFilter() {
      var filter = this.selectBoxOptions[0].dataSourceConfig.filter
        ? this.selectBoxOptions[0].dataSourceConfig.filter
        : undefined;

      if (this.fromValue) {
        if (!filter) filter = [];
        if (filter.length == 0) {
          filter.push([this.valueExpr, ">", this.fromValue]);
        }
      }
      return filter;
    },
    toFromItems() {
      var items = this.selectBoxOptions[0].dataSourceConfig.data
        ? this.selectBoxOptions[0].dataSourceConfig.data
        : undefined;

      if (items) {
        if (this.toValue) {
          return items.filter((x) => {
            return x[this.valueExpr] < this.toValue;
          });
        } else return items;
      } else return [];
    },
    toDataItems() {
      var items = this.selectBoxOptions[0].dataSourceConfig.data
        ? this.selectBoxOptions[0].dataSourceConfig.data
        : undefined;

      if (items) {
        if (this.fromValue) {
          return items.filter((x) => {
            return x[this.valueExpr] > this.fromValue;
          });
        } else return items;
      } else return [];
    },
    selectFromClearBtn() {
      return {
        icon: "clear",
        type: "clear",
        template: "select-from-clear",
        elementAttr: { class: "select-from-clear dx-clear-button-area" },
        visible: true,
      };
    },
  },
};
</script>

<style lang="scss">
.custom-auto-complete {
  .auto-complete-secondary {
    padding-left: 5px;
    font-size: 10px;
    color: gray;
  }
  .no-padding {
    padding-left: 0 !important;
  }
}

.select-box-group {
  width: 100%;
  .select-to {
    display: inline-flex;
    //   padding-top: 35px;
    span {
      vertical-align: middle;
      align-self: center;
      padding-right: 10px;
      padding-left: 5px;
    }
  }

  .select-from-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;

    .dx-icon-clear {
      color: rgba(117, 117, 117, 0.87);
      background-color: rgba(194, 194, 194, 0.87);
      border-radius: 50%;
      position: absolute;
      top: 50%;
      margin-top: -11px !important;
      width: 22px;
      height: 22px;
      background-position: 0 0;
      background-size: 12px 12px;
      padding: 0;
      font-size: 12px;
      text-align: center;
      line-height: 12px;
    }
    .dx-icon-clear::before {
      position: absolute;
      display: block;
      width: 12px;
      height: 12px;
      top: 50%;
      margin-top: -6px;
      left: 50%;
      margin-left: -6px;
    }

    .dx-inkripple .dx-inkripple-wave {
      width: 22px !important;
      height: 22px !important;
      opacity: 1 !important;
      top: 3px !important;
      left: 2px !important;
    }
  }

  .select-from-clear:hover,
  .select-from-clear:focus {
    background-color: unset;
  }
  .select-from-clear.dx-state-active {
    background-color: unset;
  }

  .select-from .dx-texteditor-input-container input.dx-texteditor-input {
    padding-right: 0 !important;
  }

  .select-to .dx-texteditor-input-container input.dx-texteditor-input {
    text-overflow: unset;
  }

  .select-from-clear {
    opacity: 1 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 25px !important;
    min-width: 25px;
  }

  .search-option {
    .dx-button-content {
      padding: 0 !important;
      .dx-icon {
        margin: 0 !important;
      }
    }
    padding: 0 !important;
  }

  .dx-dropdownbutton {
    height: auto;
  }
}

.select-box-group.select-box-multi-line {
  flex-direction: column;
  .select-to {
    padding-top: 10px;
    justify-content: space-between;
    .dx-selectbox {
      width: 100%;

      .dx-texteditor-input-container {
        > input,
        .dx-placeholder::before {
          padding-left: 6px;
        }
      }

      .dx-clear-button-area {
        padding-left: unset !important;
      }
    }
  }
}
</style>